import React, { useEffect, useState } from 'react';
import { useMap } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import 'leaflet-draw/dist/leaflet.draw.css';
import 'leaflet-draw';
import './styleLink.css'; // Import the custom CSS file

const LinkEditingHighway = ({ polylinePoints, setPolylinePoints, editMode, setLengthCableEditing, setLineEditing, selectedCity }) => {
  const map = useMap();
  const [polyline, setPolyline] = useState(null);

  useEffect(() => {
    if (!map) return;

    // Создаем новую полилинию и добавляем на карту
    const newPolyline = L.polyline(polylinePoints, { color: 'grey' }).addTo(map);
    setPolyline(newPolyline);

    if (editMode) {
      const drawnItems = new L.FeatureGroup([newPolyline]);
      map.addLayer(drawnItems);

      // Обработка редактирования полилинии
      newPolyline.on('edit', (e) => {
        const newLatLngs = e.target.getLatLngs();
        const newPoints = newLatLngs.map((latlng) => [latlng.lat, latlng.lng]);
        setPolylinePoints(newPoints);

        // Вычисляем и выводим расстояния между точками и первую точку
        const distances = [];
        let totalLength = 0;
        
        // Вычисляем длину сегментов и добавляем все точки в distances
        for (let i = 0; i < newLatLngs.length; i++) {
          const latLng = newLatLngs[i];
          const LengthSegment = i < newLatLngs.length - 1 ? Math.round(latLng.distanceTo(newLatLngs[i + 1])) : 0;
          totalLength += LengthSegment;

          distances.push({
            LengthSegment,
            City: selectedCity,
            Latitude: latLng.lat,
            Longitude: latLng.lng
          });
        }

        setLengthCableEditing(totalLength);
        setLineEditing(distances);
      });

      // Включаем редактирование
      newPolyline.editing.enable();
    }

    return () => {
      map.removeLayer(newPolyline);
    };
  }, [map, polylinePoints, setPolylinePoints, editMode]);

  useEffect(() => {
    if (polyline) {
      if (editMode) {
        polyline.editing.enable();
      } else {
        polyline.editing.disable();
      }
    }
  }, [editMode, polyline]);

  return null;
};

export default LinkEditingHighway;